import {createSelector} from 'reselect';

const SAUDI_ARABIA_COUNTRY_CODE = 'SA';

const userStateSelector = (state) => state?.user || {};
const userIpLocationSelector = createSelector(userStateSelector, (userSelector = {}) => userSelector.ipLocation || {});
const showSaudiArabiaVATSelector = createSelector(userIpLocationSelector, (ipLocation = {}) => {
  return ipLocation?.countryCode === SAUDI_ARABIA_COUNTRY_CODE;
});

export {userIpLocationSelector, showSaudiArabiaVATSelector};
